<template>
    <div class="inline-box">
        <div class="content-icon-box" @click="clickBtn('add')">
            <div>
                <div class="icon-part" style="color: #67C23A">
                    <font-awesome-icon icon="fa-solid fa-calendar-plus" />
                </div>

                <div class="text-part">
                    <span tkey="舉辦展會">{{i18n.tkey("lang_Organize_exhibitions")}}</span>
                </div>
            </div>
        </div>

        <div class="content-icon-box" style="margin-left: 30px" @click="clickBtn('join')">
            <div>
                <div class="icon-part" style="color: #409EFF">
                    <font-awesome-icon icon="fa-solid fa-earth-asia"/>
                </div>

                <div class="text-part">
                    <span tkey="參加展會">{{i18n.tkey("lang_Join_exhibitions")}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {faEarthAsia, faCalendarPlus} from '@fortawesome/free-solid-svg-icons'
import {inject} from "vue";

library.add(faEarthAsia, faCalendarPlus)

const emits = defineEmits(["clickBtn"])

const i18n = inject("i18n")

function clickBtn(name){
    emits("clickBtn", name)
}

</script>

<style scoped>

.inline-box {
    display: flex;
    justify-content: center;
    align-items: center;
}

.content-icon-box {
    width: 130px;
    height: 130px;
    text-align: center;
    border-radius: 2px;
    border: 1px #E4E7ED solid;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 2;
    background: #FAFAFA;
    user-select: none;
    cursor: pointer;
}

.content-icon-box .icon-part{
    font-size: 32px;
}

.content-icon-box .text-part{

}

</style>